import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

type Props = {
  /** Visual variant: "light" for dark hero backgrounds, "default" for cream sections, "gold" for a bold standout. */
  variant?: "light" | "default" | "gold";
  label?: string;
  className?: string;
};

export function MeetChrisVideoButton({
  variant = "default",
  label = "Watch · Meet Chris (2 min)",
  className = "",
}: Props) {
  const [open, setOpen] = useState(false);

  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-smooth";
  const styles =
    variant === "gold"
      ? "bg-gradient-gold !px-8 !py-4 !text-base !font-extrabold text-brand-black shadow-gold hover:-translate-y-0.5 hover:shadow-card-hover"
      : variant === "light"
      ? "border border-white/40 bg-white/10 text-white backdrop-blur hover:border-white/70 hover:bg-white/20"
      : "border border-brand-gold-deep/40 bg-brand-gold/10 text-brand-gold-deep hover:border-brand-gold-deep hover:bg-brand-gold/20";

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`${base} ${styles} ${className}`}
        aria-label="Watch the 2-minute intro video about Chris and Colorado Web Impressions"
      >
        <PlayCircle className="h-5 w-5 transition-spring group-hover:scale-110" />
        {label}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl border-white/10 bg-brand-black p-0 sm:p-0">
          <DialogTitle className="sr-only">
            Meet Chris Heidlebaugh — About Colorado Web Impressions
          </DialogTitle>
          <div className="relative aspect-video w-full overflow-hidden rounded-lg">
            {open && (
              <iframe
                src="https://www.youtube-nocookie.com/embed/t3no84uGrms?rel=0&modestbranding=1&autoplay=1"
                title="About Colorado Web Impressions — Meet Chris Heidlebaugh"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                className="absolute inset-0 h-full w-full"
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
